import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useLeaderBoardSubscribeSummary = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.ILeaderBoardSubscribeSummaryRequestData) => {
        const response = await send<
            Types.ILeaderBoardSubscribeSummaryRequestData,
            Types.ILeaderBoardSubscribeSummaryResponseData
        >({
            ID: 71010,
            responses: [71011, 71012],
            description: 'Subscribe Leaderboards Summary notifications',
            ...options
        });

        return response;
    }, [send]);
};
